export default __webpack_public_path__ + "static/media/zulip.913891a3.png";